import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsSdmailRoute: InvariantJiraRoute = {
	name: 'global-settings-products-sdmail',
	path: '/secure/admin/SDMailInfo.jspa',
};
